<template>
    <div class="result-main-box">
        <a-spin :spinning="spinning" size="large">
        <!-- isResultSearch: 是否为当前列表页检索 -->
        <resultNav 
            :isResultSearch="true"
            @changeTab="changeTab" 
            @simpleSearch2="simpleSearch2" 
            @advancedSearch2="advancedSearch2"
            @professSearch2="professSearch2"
        />
        <!--  class="result-main" -->
        <div :class="tabIndex===1 ? 'result-main cur' : 'result-main'">
            <div class="top-ctrl">
                <span @click="resultExport"><i></i><img src="./img/icon4.png" alt=""> 结果导出</span>
                <span @click="charts"><img src="./img/icon5.png" alt=""> 结果可视化</span>
                <span @click="gisAnalysis"><img src="./img/icon6.png" alt=""> GIS分析</span>
                <!-- <a-modal :visible="modalStatus" cancelText="取消" okText="确定" centered="true"> Info </a-modal> -->
            </div>
            <div class="result-container">
                <div class="left-box">
                    <!--  v-if="!namesIsEmpty" -->
                    <div class="ts">
                        {{searchCondition}}检索<span>人名规范库</span>得到<span>{{namesSize}}</span>个结果
                    </div>
                    <div :class="animateFlag?'info-box cur':'info-box'">
                        <div v-if="!namesIsEmpty">
                            <div class="taps">
                                <span v-for="(lt, index) in namesList.slice(0, 3)" :key="lt.name+index" 
                                    :class="infoTap===index?'cur':''" @click="changeInfoTap(lt, index)" 
                                    v-html="highLight(lt.name)"
                                ></span>
                            </div>
                            <div class="detail" v-if="namesInfo">
                                <img v-if="namesInfo.img" :src="namesInfo.img+'!500x500'" alt="图片">
                                <div class="txt">
                                    <p v-if="namesInfo.briefBiography">{{namesInfo.briefBiography.slice(0, 40)+'......'}}</p>
                                    <table>
                                        <!-- <tr v-if="!isEmpty(namesHandle('原名', '', namesInfo.yName))">
                                            <td>原名</td><td>{{namesHandle('原名', '', namesInfo.yName)}}</td>
                                        </tr> -->
                                        <tr v-if="namesInfo.name">
                                            <td>姓名</td><td>{{namesInfo.name}}</td>
                                        </tr>

                                        <tr v-if="namesInfo.birthday && namesInfo.deathday">
                                            <td>生卒</td><td>{{namesInfo.birthday+'-'+namesInfo.deathday}}</td>
                                        </tr>
                                        <tr v-else-if="namesInfo.birthday">
                                            <td>生卒</td><td>{{namesInfo.birthday+'-'}}</td>
                                        </tr>
                                        <tr v-else-if="namesInfo.deathday">
                                            <td>生卒</td><td>{{'-'+namesInfo.deathday}}</td>
                                        </tr>

                                        <tr v-if="namesInfo.place">
                                            <td>籍贯</td><td>{{namesInfo.place}}</td>
                                        </tr>
                                        <tr v-if="namesInfo.gender">
                                            <td>性别</td><td>{{namesInfo.gender}}</td>
                                        </tr>
                                        <tr v-if="namesInfo.ethnicity">
                                            <td>民族</td><td>{{namesInfo.ethnicity}}</td>
                                        </tr>
                                        <tr v-if="namesInfo.dynasty">
                                            <td>朝代</td><td>{{namesInfo.dynasty}}</td>
                                        </tr>
                                        <tr v-if="!isEmpty(namesHandle('字', '号', namesInfo.yName))">
                                            <td>字号</td><td>{{namesHandle('字', '号', namesInfo.yName)}}</td>
                                        </tr>
                                        <!-- <tr v-if="!isEmpty(namesHandle('谥号', '諡號', namesInfo.yName))">
                                            <td>谥号</td><td>{{namesHandle('谥号', '諡號', namesInfo.yName)}}</td>
                                        </tr> -->
                                        <tr>
                                            <td colspan="2">...</td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <!-- 检索为空时显示介绍 -->
                        <div v-else>
                            <!-- <h4><span>人名规范库</span> 有 <span>{{namesStaticSize}}</span> 种数据</h4> -->
                            <div class="detail cur">
                                <div class="txt">
                                    <p>
                                        <span>人名规范库</span>有<span>{{namesStaticSize}}</span>个名人。
                                        {{Common.namesDescription}}
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div class="bottom" :class="{'cur' : namesSize == 0}">
                            <div v-if="namesList && namesSize > 0">
                                <a href="//names.library.sh.cn/mrgf/service/person/list" target="_blank" v-if="!keyword">
                                    <span class="more">
                                        <a-icon style="font-size: 20px;" type="ellipsis"/>
                                    </span>
                                </a>
                                <a :href="'//names.library.sh.cn/mrgf/service/person/list?freetext='+keyword" target="_blank" v-else>
                                    <span class="more">
                                        <a-icon style="font-size: 20px;" type="ellipsis"/>
                                    </span>
                                </a>
                            </div>
                            <div v-if="!namesIsEmpty">
                                <div class="ot">
                                    <!-- <router-link to="/"> -->
                                    <a v-if="namesInfo && namesInfo.uri" :href="namesInfo.uri" target="_blank">
                                        <img src="./img/icon1.png" alt="">
                                        人物详情
                                    </a>
                                    <!-- </router-link> -->
                                    <!-- :href="'https://dhc.library.sh.cn/uc/relation.html?uri='+namesInfo.uri+'&token='+getTokenFunc()" target="_blank" -->
                                    <a v-if="namesInfo && namesInfo.uri" href="javascript:;"
                                        @click="onRelation(namesInfo.uri, null)"
                                    >
                                        <img src="./img/icon2.png" alt="">
                                        关系图谱
                                    </a>
                                </div>
                            </div>
                            <div v-else>
                                <div class="ot">
                                    <a href="//names.library.sh.cn/" class="all look" target="_blank">
                                        <img src="./img/icon3.png" alt=""> 查看
                                    </a>
                                </div> 
                            </div> 
                        </div>
                    </div>
                    
                    <div :class="animateFlag?'waterfall-list cur':'waterfall-list'" v-if="photoList">
                        <ul>
                            <li v-for="(lt, index) in photoList.slice(0, 3)" :key="index">
                                <img :src="lt.imgPath" alt="" @click="photoEvent(lt)">
                            </li>
                        </ul>
                        <ul>
                            <li v-for="(lt, index) in photoList.slice(3, 6)" :key="index">
                                <img :src="lt.imgPath" alt="" @click="photoEvent(lt)">
                            </li>
                        </ul>
                        <ul>
                            <li v-for="(lt, index) in photoList.slice(6, 9)" :key="index">
                                <img :src="lt.imgPath" alt="" @click="photoEvent(lt)">
                            </li>
                        </ul>
                    </div>
                </div>
                <div :class="animateFlag?'middle-result cur':'middle-result'">
                    <div class="re-tit">
                        <span class='check-all' v-if="Common.userInfo && totalSize > 0">
                            <a-checkbox 
                                @change="onCheckAllModelChange"
                                :checked="checkAllModel" 
                                :indeterminate="indeterminate" 
                            ></a-checkbox>
                        </span>
                        找到 {{totalSize}} 个结果<a-divider style="background: #f0be73;" type="vertical" />用时 {{totalTime}} 秒
                    </div>
                    <div class="result-from" v-if="fullWxItemsList">
                        <transition-group tag="div" class="transition-container">
                            <div :class="wxModelHide(fitem) || !fitem.type ? 'from-cell item cur '+fitem.type : 'from-cell item '+fitem.type"
                                v-for="(fitem, index) in fullWxItemsList" :key="'fullWxItemsList'+index" draggable="true"
                                @dragstart="handleDragStart($event, fitem)"
                                @dragover.prevent="handleDragOver($event, fitem)"
                                @dragenter="handleDragEnter($event, fitem)" 
                                @dragend="handleDragEnd($event, fitem)" 
                            >
                                <!-- <b>家谱</b> -->
                                <b>{{fitem.wxName}}</b>
                                <div class="arr">
                                    <span></span>
                                    <div v-if="fitem.data && fitem.data.length > 3">
                                        <a-icon @click="showMore(fitem)" :type="getShowMore(fitem)?'up':'down'" class="arrow"></a-icon>
                                    </div>
                                </div>
                                <div class="ct-nox">
                                    <div class="ts">
                                        <span class='check-all' v-if="Common.userInfo && !wxSearchIsEmpty(fitem) && fitem.type">
                                            <!-- :value="fitem.type+'CheckedAllGroup'" -->
                                            <a-checkbox 
                                                @change="onCheckAllChange($event, fitem.type)"
                                                :indeterminate="setIndeterminate(fitem)" 
                                                :checked="setCheckedAll(fitem)" 
                                            ></a-checkbox>
                                        </span><!-- 
                                        -->{{searchCondition}}检索<span>{{fitem.wxFullName}}</span>得到<span>{{fitem.size}}</span>个结果
                                    </div>
                                    
                                    <div v-if="!wxSearchIsEmpty(fitem)">
                                        <ul :class="{ 'cur' : !getShowMore(fitem)}" :style="{height:24*(getShowMore(fitem) && fitem.data.length>3?fitem.data.length:3)+'px'}">
                                            <a-checkbox-group v-if="fitem.type" 
                                                @change="onCheckChange($event, fitem.type)"
                                                :value="setCheckedList(fitem)"  
                                            >
                                                <li v-for="(lt, ltIndex) in (getShowMore(fitem)?fitem.data:fitem.data.slice(0, 3))" :key="'liList'+ltIndex" 
                                                    :class="(getShowMore(fitem)?true:(ltIndex<3))?'cur':''"
                                                >
                                                    <span v-if="Common.userInfo">
                                                        <a-checkbox :value="lt"></a-checkbox>
                                                    </span>&nbsp;
                                                    <!-- singleSkip target="_blank" -->
                                                    <a href="javascript:;" @click="browseHistoryMark(lt, fitem)"
                                                    >{{lt.title.value}}</a>
                                                </li>
                                            </a-checkbox-group>
                                        </ul>
                                    </div>
                                    <!-- 检索为空时显示介绍 -->
                                    <div v-else>
                                        <span>{{fitem.wxFullName}}</span>有<span>{{fitem.staticSize}}</span>种{{fitem.wxArticleName}}。
                                        {{Common[fitem.type+'Description']}}
                                    </div>

                                    <div v-if="!wxSearchIsEmpty(fitem)">
                                        <div class="more">
                                            <span v-if="fitem.data && fitem.data.length>3" @click="showMore(fitem)">{{getShowMore(fitem)?'收起搜索结果':'展开搜索结果'}}</span>
                                            <span v-else></span>
                                            <span>
                                                <a href="javascript:;" class="all" @click="skipSearchAll(fitem)">
                                                    <img src="./img/icon3.png" alt=""> 查看全部
                                                </a>
                                            </span>
                                        </div>
                                    </div>
                                    <div v-else>
                                        <div class="more">
                                            <span></span>
                                            <a href="javascript:;" class="all"  @click="lookSkip(fitem)">
                                                <img src="./img/icon3.png" alt=""> 查看
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </transition-group>
                    </div>
                </div>
                <div :class="animateFlag?'right-act cur':'right-act'" v-if="!eventIsEmpty">
                    <div class="top-act" v-if="bigEventData && bigEventCode == 1">
                        <img src="./img/tag.png" alt="" class="tag">
                        <img v-for="(img, n) in bigEventData.imageList" :key="n" :src="img.eventImagePath+'!300x300'" alt="" class="pic">
                        <h4>{{bigEventData.title}}</h4>
                        <p class="y"><a-icon type="caret-right" />{{bigEventData.begin}}</p>
                        <div class="des" v-html="replaceHighlight(bigEventData.description)"></div>
                        <div class="btn">
                            <a href="javascript:;"><img src="./img/icon7.png" alt="">知识图谱</a>
                            <a :href="'http://memory.library.sh.cn/node/'+bigEventData.nodeId" target="_blank">
                                <a-icon style="color:#f0be73;margin-right: 3px; " type="ellipsis" />展开详情
                            </a>
                        </div>
                    </div>
                    <!-- 检索时显示介绍 -->
                    <div class="top-act" v-else>
                        <img src="./img/tag.png" alt="" class="tag">
                        <!-- <img src="/demo.jpg" alt="" class="pic"> -->
                        <!-- <h4 class="event-title"><span>上海历史文化事件知识库</span> 有 <span>{{eventStaticSize}}</span> 种数据</h4> -->
                        <div class="des">
                            <span>上海历史文化事件知识库</span>有<span>{{eventStaticSize}}</span>种事件。
                            {{Common.eventDescription}}
                        </div>
                        <div class="btn">
                            <a href="//data.library.sh.cn/shnh/event/webapi/tolist" class="all cur" target="_blank">
                                <img src="./img/icon3.png" alt=""> 查看
                            </a>
                        </div>
                    </div>

                    <div class="ts">
                        {{searchCondition}}检索<span>上海历史文化事件知识库</span>得到<span>{{eventSize}}</span>个结果
                    </div>
                    <div class="years-act">
                            
                        <div class="years">
                            <div class="line">
                                <div class="l"></div>
                            </div>
                            <ul v-if="yearArray && yearArray.length > 0">
                                <li v-for="(lt, index) in yearArray" :key="index" :class="yearSlide == index?'year-t cur':'year-t'">
                                    <p @click="eventTimeline(lt, index)">
                                        {{lt}} <a-icon :type="yearSlide == index?'down':'right'" style="color:#f0be73;" />
                                    </p>
                                    <ul :class="yearSlide == index?'slide-more cur':'slide-more'">
                                        <!-- <li v-for="i in 10" :key="Number(lt)+i-1" 
                                            @click="yearClick(Number(lt)+i-1)">{{Number(lt)+i-1}}</li> -->
                                        <li v-for="item in year" :key="item" @click="yearClick(item)">{{item}}</li>
                                    </ul>
                                </li>
                            </ul>
                        </div>
                        <div class="acts">
                            <div class="act-cell" v-for="(lt, index) in this.eventList" :key="index">
                                <h4 :class="{'cur': eventColorFlag == index}">
                                    <a href="javascript:scrollTo(0,0);" @click="eventTitleClick(lt, index)">{{lt.title}}</a>
                                </h4>
                                <p class="y"><a-icon type="caret-right" />{{lt.begin}}至{{lt.end}}</p>
                                <div class="des" v-html="replaceHighlight(lt.description)"></div>
                                <div class="btn">
                                    <!-- <a href="javascript:;"><img src="./img/icon7.png" alt="">知识图谱</a> -->
                                    <a :href="'http://memory.library.sh.cn/node/'+lt.nodeId" target="_blank">
                                        <a-icon style="color:#f0be73;margin-right: 3px; " type="ellipsis" />展开详情
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 检索为空时显示介绍 -->
                <div :class="animateFlag?'right-act cur':'right-act'" v-else>
                    <div class="top-act">
                        <img src="./img/tag.png" alt="" class="tag">
                        <img src="/demo.jpg" alt="" class="pic">
                        <h4 class="event-title"><span>上海历史文化事件知识库</span> 有 <span>{{eventStaticSize}}</span> 种数据</h4>
                        <div class="des">{{Common.eventDescription}}</div>
                        <div class="btn">
                            <a href="//data.library.sh.cn/shnh/event/webapi/tolist" class="all cur" target="_blank">
                                <img src="./img/icon3.png" alt=""> 查看
                            </a>
                        </div>
                    </div>
                </div>

            </div>
        </div>
        </a-spin>
    </div>
</template>

<script>
    import resultNav from '../../components/resultNav'
    export default {
        components:{
            resultNav
        },
        data(){
            return{
                infoTap:0,
                spinning: false, // 加载中...
                settingBody: {}, // 拖拽顺序body参数
                searchid: '',    // 检索参数存储到索引库中的返回值
                keyword:'',
                tabIndex: 0,
                indeterminateModelList: [], // 所有检索模块复选框状态，若右值则表示有复选框选中
                checkedAllModelList: [],    // 最外层复选框数据
                plainOptions: [],           // 最外层复选框中子复选框的值
                indeterminate: false,       // 最外层复选框中子复选框是否选中
                checkAllModel: false,       // 最外层复选框是否选中
                searchCondition: '',        // 检索提示
                showMore1:false,
                showMore2:false,
                showMore3:false,
                showMore4:false,
                showMore5:false,
                showMore6:false,
                showMore7:false,
                yearSlide0:false,
                yearSlide1:false,
                yearSlide2:false,
                yearSlide3:false,
                yearSlide4:false,
                yearSlide5:false,
                yearSlide6:false,
                yearSlide7:false,
                yearSlide8:false,
                yearSlide9:false,
                yearSlide: -1,
                animateFlag:false,
                jpHide   : false,
                gjHide   : false,
                sdHide   : false,
                bkHide   : false,
                bkMagHide: false,
                hswxHide : false,
                jdtsHide : false,
                cdtn: [],           // 高级检索参数
                facet:{},           // 人物点击分面参数
                DT: [ 'BK', 'JP', 'GJ', 'SD', 'JDTS', 'HSWX' ], // 文献勾选
                searchType: "1",    // 接口检索类型 1：简单检索，2：高级检索，3：专业检索
                expression: "",     // 专业检索参数
                startTime: 0,       // 开始时间
                endTime: 0,         // 结束时间
                isFirstPerson: true, // 默认显示第一个人
                yearArray:     [],
                yearDataArray: [],
                year:          [],
                agentUriArray: [], // 高级检索所有文献人物uri集合
                ajaxStopFlag: 0,   // 判断所有请求是否完成
                pageSize: 10, // 默认显示 10条/页
                // 名人
                namesIsEmpty: false,      // 检索是否为空
                namesSize: 0,
                namesList: [],            // 人物数据
                namesCdtn: [],            // 名人 高级检索参数
                namesInfo: null,
                namesFacetParam: '',
                namesStaticSize: 1332441, // 总数（固定值）
                namesTimer: null,         // 人物延时判断
                // 照片
                photoSize: 0,
                photoList: [],
                // 事件
                eventIsEmpty: false,    // 检索是否为空
                eventSize: 0,
                bigEventCode: 0,
                eventColorFlag: -1,
                bigEventData: null,     // 页面右上角大事件详情
                eventList: [],          // 事件数据
                eventFreetext: '',      // 事件相关人物
                eventStaticSize: 7481,  // 总数（固定值）
                // 家谱
                jpIsEmpty: false, // 检索是否为空
                jpSize: 0,
                jpList: [],
                jpStaticSize: 71823,    // 总数（固定值）
                jpSortIndex: 0,         // 家谱排序位置
                jpCheckedList: [],      // 家谱内容勾选数据
                jpCheckAll: false,      // 家谱模块复选框全选
                jpIndeterminate: false, // 家谱内容勾选但不是全选
                jpCheckedAllList: [],   // 家谱复选框全选数据
                jpTimer: null,          // 家谱延时判断
                // 古籍
                gjIsEmpty: false, // 检索是否为空
                gjSize: 0,
                gjList: [],
                gjStaticSize: 602451,   // 总数（固定值）
                gjSortIndex: 1,         // 古籍排序位置
                gjCheckedList: [],      // 古籍内容勾选数据
                gjCheckAll: false,      // 古籍模块复选框全选
                gjIndeterminate: false, // 古籍内容勾选但不是全选
                gjCheckedAllList: [],   // 古籍复选框全选数据
                gjTimer: null,          // 古籍延时判断
                // 盛档
                sdIsEmpty: false, // 检索是否为空
                sdSize: 0,
                sdList: [],
                sdStaticSize: 178517,   // 总数（固定值）
                sdSortIndex: 2,         // 盛档排序位置
                sdCheckedList: [],      // 盛档内容勾选数据
                sdCheckAll: false,      // 盛档模块复选框全选
                sdIndeterminate: false, // 盛档内容勾选但不是全选
                sdCheckedAllList: [],   // 盛档复选框全选数据
                sdTimer: null,          // 盛档延时判断
                // 报刊(报)
                bkIsEmpty: false, // 检索是否为空
                bkSize: 0,
                bkList: [],
                bkStaticSize: 512,      // 总数（固定值）
                bkSortIndex: 3,         // 报刊(报)排序位置
                bkCheckedList: [],      // 报刊(报)内容勾选数据
                bkCheckAll: false,      // 报刊(报)模块复选框全选
                bkIndeterminate: false, // 报刊(报)内容勾选但不是全选
                bkCheckedAllList: [],   // 报刊(报)复选框全选数据
                bkTimer: null,          // 报刊(报)延时判断
                // 报刊(刊)
                bkMagIsEmpty: false, // 检索是否为空
                bkMagSize: 0,
                bkMagList: [],
                bkMagStaticSize: 8,         // 总数（固定值）
                bkMagSortIndex: 4,          // 报刊(刊)排序位置
                bkMagCheckedList: [],       // 报刊(刊)内容勾选数据
                bkMagCheckAll: false,       // 报刊(刊)模块复选框全选
                bkMagIndeterminate: false,  // 报刊(刊)内容勾选但不是全选
                bkMagCheckedAllList: [],    // 报刊(刊)复选框全选数据
                bkMagTimer: null,           // 报刊(刊)延时判断
                // 红色文献
                hswxIsEmpty: false, // 检索是否为空
                hswxSize: 0,
                hswxList: [],
                hswxStaticSize: 8505,       // 总数（固定值）
                hswxSortIndex: 5,           // 红色文献排序位置
                hswxCheckedList: [],        // 红色文献内容勾选数据
                hswxCheckAll: false,        // 红色文献模块复选框全选
                hswxIndeterminate: false,   // 红色文献内容勾选但不是全选
                hswxCheckedAllList: [],     // 红色文献复选框全选数据
                hswxTimer: null,            // 红色文献延时判断
                // 近代图书
                jdtsIsEmpty: false, // 检索是否为空
                jdtsSize: 0,
                jdtsList: [],
                jdtsStaticSize: 124402,     // 总数（固定值）
                jdtsSortIndex: 6,           // 近代图书排序位置
                jdtsCheckedList: [],        // 近代图书内容勾选数据
                jdtsCheckAll: false,        // 近代图书模块复选框全选
                jdtsIndeterminate: false,   // 近代图书内容勾选但不是全选
                jdtsCheckedAllList: [],     // 近代图书复选框全选数据
                jdtsTimer: null,            // 近代图书延时判断
                dragging: null, // 元素移动参数配置
                fullWxItemsList: [
                    {id:1}, {id:2}, {id:3}, {id:4}, {id:5}, {id:6}, {id:7}
                ],
                wxFullInfo: {
                    jp: [
                        '家谱', 
                        '家谱', 
                        '中国家谱知识服务平台',
                        '//jiapu.library.sh.cn/',                       // 查看
                        '//jiapu.library.sh.cn/#/genealogyFullSearch',  // 查看全部
                        '//jiapu.library.sh.cn/#/GenealogySummary:'     // 标题点击，当前数据详情
                    ],
                    gj: [
                        '古籍',
                        '古籍', 
                        '中文古籍聯合目錄及循證平臺',
                        '//gj.library.sh.cn/',                              // 查看
                        '//gj.library.sh.cn/unionCatalogue/search',         // 查看全部
                        '//gj.library.sh.cn/unionCatalogue/work/list#uri='  // 标题点击，当前数据详情
                    ],
                    sd:    [
                        '盛档', 
                        '盛档', 
                        '盛宣怀档案知识库',
                        '//sd.library.sh.cn/',                          // 查看
                        '//sd.library.sh.cn/sd/service/search/more',    // 查看全部
                        '//sd.library.sh.cn/sd/service/work/list#uri='  // 标题点击，当前数据详情
                    ],
                    bk:    [
                        '报刊(报)', 
                        '报纸', 
                        '近代报刊资源库',
                        '//dhc.library.sh.cn/bk/literature',            // 查看
                        '//dhc.library.sh.cn/bk/literature',            // 查看全部
                        '//dhc.library.sh.cn/bk/newspaperDetail?uri='   // 标题点击，当前数据详情
                    ],
                    bkMag: [
                        '报刊(刊)',
                        '期刊',
                        '近代报刊资源库',
                        '//dhc.library.sh.cn/bk/literature',            // 查看
                        '//dhc.library.sh.cn/bk/literature',            // 查看全部
                        '//dhc.library.sh.cn/bk/magazineDetail?uri='    // 标题点击，当前数据详情
                    ],
                    hswx:  [
                        '红色文献',
                        '红色文献',
                        '革命（红色）文献服务平台',
                        '//red.library.sh.cn/',                     // 查看
                        '//red.library.sh.cn/searchInstanceMore',   // 查看全部
                        '//red.library.sh.cn/instanceDetail?data='  // 标题点击，当前数据详情
                    ],
                    jdts:  [
                        '近代图书',
                        '近代图书',
                        '中国近代图书全文数据库',
                        '//jdts.library.sh.cn/',           // 查看
                        '//jdts.library.sh.cn/moreSearch', // 查看全部
                        '//jdts.library.sh.cn/?uri='       // 标题点击，当前数据详情
                    ],
                },
                finalStaticDT:['BK', 'JP', 'GJ', 'SD', 'HSWX', 'JDTS'],
                isFirstDrag: true, // 初始获取拖拽历史
            }
        },
        mounted() {
            setTimeout(()=>{
                this.animateFlag = true
            },100)

            this.$nextTick(()=>{
                // setTimeout(() => {
                //     this.getModelSortIndex(); // 获取文献模块历史位置
                // }, 200);
                // 检索开始
                // this.startTime = new Date().getTime();  // 开始时间
                // this.searchAll();
            })
        },
        computed:{
            params(){
                return {
                    "searchType": this.searchType,  // 检索类型，1：简单检索，2：高级检索，3：专业检索
                    "freetext"  : this.keyword,     // 简单检索参数
                    "expression": this.expression,  // 专业检索参数
                    "cdtn"      : this.activeCdtn,  // 高级检索参数
                    "facet"     : this.facet,       // 分面检索参数
                    "secondCdtn": "",
                    "pager": {
                        "pageth": 1,
                        "pageSize": this.pageSize   // 每页显示总数
                    },
                    "sorts": {},
                    "hasFacet": false
                };
            },
            settingParams(){
                return {
                    "appId"  : "history",
                    "userId" : this.Common.userInfo.id,
                    "version": "1.0",
                    "token"  : this.getTokenFunc(),
                    "body"   : this.settingBody
                }
            },
            totalSize(){ // 文献总数量
                return this.jpSize + 
                       this.gjSize + 
                       this.sdSize + 
                       this.bkSize + 
                       this.bkMagSize + 
                       this.hswxSize;
            },
            totalTime(){ // 检索总用时
                let timer = this.endTime >= this.startTime ? (this.endTime - this.startTime)/1000 : 0;
                return timer;
            },
            activeCdtn: function(){
                return this.cdtn.filter(function(item) {
                    return item.value
                })
            },
            activeUserInfo(){
                return this.Common.userInfo;
            }
        },
        methods:{
            toInit(){ // 数据初始化
                this.infoTap   = 0;
                this.yearSlide = -1;
                this.DT    = [ 'BK', 'JP', 'GJ', 'SD', 'JDTS', 'HSWX']; // 文献模块
                this.cdtn  = [];
                this.facet = {};
                this.pageSize = 10;
                this.searchCondition  = '';       // 检索提示, 以...检索
                this.namesFacetParam = '';        // 人物点击参数清空
                this.ajaxStopFlag  = 0;           // 异步请求数量归零
                this.agentUriArray = [];          // 清空所有人物url
                this.indeterminateModelList = []; // 复选框状态，若有值则表示有复选框选中
                this.checkedAllModelList = [];    // 最外层复选框数据
                this.plainOptions   = [];         // 最外层复选框中子复选框的值
                this.indeterminate  = false;      // 最外层复选框中子复选框是否选中
                this.checkAllModel  = false;      // 最外层复选框是否选中
                this.showMore1 = false;
                this.showMore2 = false;
                this.showMore3 = false;
                this.showMore4 = false;
                this.showMore5 = false;
                this.showMore6 = false;
                this.showMore7 = false;
                // 名人
                this.namesIsEmpty = false;
                this.namesSize  = 0;
                this.namesList  = [];
                this.namesInfo = null;
                this.namesCdtn  = [];
                // 照片
                this.photoSize = 0;
                this.photoList = [];
                // 事件
                this.eventIsEmpty   = false;
                this.eventSize      = 0;
                this.bigEventCode   = 0;
                this.bigEventData   = null;
                this.eventColorFlag = -1;
                this.eventList      = [];
                this.eventFreetext  = '';
                this.yearArray      = [];
                // 家谱
                this.jpIsEmpty  = false;
                this.jpSize     = 0;
                this.jpList     = [];
                this.jpCheckedList = [];
                this.jpCheckAll = false;
                this.jpIndeterminate = false;
                this.jpCheckedAllList = [];
                // 古籍
                this.gjIsEmpty = false;
                this.gjSize    = 0;
                this.gjList    = [];
                this.gjCheckedList = [];
                this.gjCheckAll = false;
                this.gjIndeterminate = false;
                this.gjCheckedAllList = [];
                // 盛档
                this.sdIsEmpty = false;
                this.sdSize    = 0;
                this.sdList    = [];
                this.sdCheckedList = [];
                this.sdCheckAll = false;
                this.sdIndeterminate = false;
                this.sdCheckedAllList = [];
                // 报刊(报)
                this.bkIsEmpty = false;
                this.bkSize    = 0;
                this.bkList    = [];
                this.bkCheckedList = [];
                this.bkCheckAll = false;
                this.bkIndeterminate = false;
                this.bkCheckedAllList = [];
                // 报刊(刊)
                this.bkMagIsEmpty = false;
                this.bkMagSize    = 0;
                this.bkMagList    = [];
                this.bkMagCheckedList = [];
                this.bkMagCheckAll = false;
                this.bkMagIndeterminate = false;
                this.bkMagCheckedAllList = [];
                // 红色文献
                this.hswxIsEmpty = false;
                this.hswxSize    = 0;
                this.hswxList    = [];
                this.hswxCheckedList = [];
                this.hswxCheckAll = false;
                this.hswxIndeterminate = false;
                this.hswxCheckedAllList = [];
                // 近代图书
                this.jdtsIsEmpty = false;
                this.jdtsSize    = 0;
                this.jdtsList    = [];
                this.jdtsCheckedList = [];
                this.jdtsCheckAll = false;
                this.jdtsIndeterminate = false;
                this.jdtsCheckedAllList = [];
            },
            browseHistoryMark(lt, fitem){ // 浏览历史埋点
                let _OPEN_URL = fitem.wxALink+lt['@id'];
                window.open(_OPEN_URL);

                // 浏览历史埋点START
                if(this.activeUserInfo){
                    this.browseHistory({
                        title   : lt.title.value,
                        subTitle: "无", // 子标题
                        content : "历史人文大数据平台文献检索",   // 历史人文大数据平台文献检索列表
                        image: "",
                        url  : _OPEN_URL,
                        releaseType: "B",
                        sourceType: {
                            id  : fitem.wxLook, // "https://dhc.library.sh.cn/result"
                            name: lt.DTNAME,
                        },
                        dataType: {
                            id  : "https://dhc.library.sh.cn/",
                            name: "历史人文大数据平台",
                        },
                        source: {
                            id  : fitem.wxLook,
                            name: lt.DTNAME,
                        }
                    });
                }
                // 浏览历史埋点END
            },
            skipSearchAll(data){ // 查看全部，传递检索条件
                let _type = data.type;
                if(_type == 'bk') localStorage.iframeIndex = 0;
                if(_type == 'bkMag') localStorage.iframeIndex = 1;
                window.open(data.wxLookAll+"?searchid="+this.searchid);
            },
            lookSkip(data){ // 查看
                let _type = data.type;
                if(_type == 'bk') localStorage.iframeIndex = 0;
                if(_type == 'bkMag') localStorage.iframeIndex = 1;
                window.open(data.wxLook);
            },
            setFullWxItemsList(type){ // 文献各模块数据设置
                let _sortIndex = this[type+'SortIndex'];
                let _index     = _sortIndex+1;
                this.fullWxItemsList[_sortIndex].key             = _index;
                this.fullWxItemsList[_sortIndex].wxModelHide     = type+'Hide';
                this.fullWxItemsList[_sortIndex].wxSearchIsEmpty = type+'IsEmpty';
                this.fullWxItemsList[_sortIndex].wxName          = this.wxFullInfo[type][0];
                this.fullWxItemsList[_sortIndex].wxArticleName   = this.wxFullInfo[type][1];
                this.fullWxItemsList[_sortIndex].wxFullName      = this.wxFullInfo[type][2];
                this.fullWxItemsList[_sortIndex].wxLook          = this.wxFullInfo[type][3];
                this.fullWxItemsList[_sortIndex].wxLookAll       = this.wxFullInfo[type][4];
                this.fullWxItemsList[_sortIndex].wxALink         = this.wxFullInfo[type][5];
                this.fullWxItemsList[_sortIndex].data            = this[type+'List'];
                this.fullWxItemsList[_sortIndex].size            = this[type+'Size'];
                this.fullWxItemsList[_sortIndex].staticSize      = this[type+'StaticSize'];
                this.fullWxItemsList[_sortIndex].showMoreFlag    = 'showMore'+_index;
                this.fullWxItemsList[_sortIndex].type            = type;
            },
            setCheckedList(fitem){ // 各文献模块全选数据
                let key = fitem.type+'CheckedList';
                return this[key]
            },
            setCheckedAll(fitem){ // 各文献模块是否全选
                let key = fitem.type+'CheckAll';
                return this[key]
            },
            setIndeterminate(fitem){ // 各文献模块内容是否存在勾选
                let key = fitem.type+'Indeterminate';
                return this[key]
            },
            wxSearchIsEmpty(fitem){ // 判断检索是否为空
                let key = fitem.wxSearchIsEmpty;
                return this[key]
            },
            wxModelHide(fitem){ // 检索时是否参与检索，判断文献模块是否隐藏
                let key = fitem.wxModelHide;
                return this[key]
            },
            showMore(fitem){ // 文献下拉判断
                let key = fitem.showMoreFlag;
                this[key] = !this[key];
                return this[key];
            },
            getShowMore(fitem){
                let key = fitem.showMoreFlag;
                return this[key];
            },
            changeTab(index){
                this.tabIndex = index;
            },
            searchDataAll(){
                this.namesSearchData();   // 名人
                this.photoSearchData();   // 照片
                this.eventSearchData();   // 事件
                this.searchAllTypeData(); // 文献模块检索
            },
            defaultShowModule(data){ // 所有文献模块显示, 并进行简单检索
                this.searchType = data.searchType;   // 接口请求类型
                this.keyword    = data.simpleKeyword;
                if(!this.isEmpty(this.keyword)) this.searchCondition = '以“'+ this.keyword +'”';
                this.showSearchModel(); // 显示所有文献
                this.searchDataAll();

                // 检索埋点START
                if(this.activeUserInfo) {
                    this.params.DT = this.DT;
                    this.createUserLog("https://dhc.library.sh.cn/result", this.params, "大数据平台-知识检索")
                }
                // 检索埋点END

                // 检索历史埋点START
                if(this.activeUserInfo) {
                    let _history = {
                        "content": JSON.stringify(this.params)
                    }
                    if(this.isEmpty(this.params.freetext)) _history = null;
                    this.hisRetAndOrdSetting(null, _history, null);
                }
                // 检索历史埋点END

                /* 检索参数存储索引库 START */
                this.dhcLogSearchid();
                /* 检索参数存储索引库 END   */
            },
            simpleSearch2(data){ // 列表页-简单检索
                this.spinning = true; // 加载中...
                setTimeout(async () => {
                    if(this.isFirstDrag){
                        await this.getModelSortIndex(); // 获取文献模块历史位置
                        this.isFirstDrag = false;
                    }
                    this.startTime = new Date().getTime();  // 开始时间
                    this.toInit();                          // 初始化所有数据
                    this.defaultShowModule(data);           // 检索所有文献
                    this.replaceUrl2('?historyParams='); // 无刷新，改变地址栏
                }, 300);
            },
            advancedSearch2(data){ // 列表页-高级检索
                this.spinning = true; // 加载中...
                setTimeout(async () => {
                    if(this.isFirstDrag){
                        await this.getModelSortIndex(); // 获取文献模块历史位置
                        this.isFirstDrag = false;
                    }
                    this.toInit();                           // 初始化所有数据
                    this.searchType    = data.searchType;    // 各个uri请求类型为高级检索，1：简单检索，2：高级检索，3：专业检索
                    this.DT            = data.DT;            // 参与检索的文献
                    this.cdtn          = data.filters;       // 高级检索参数
                    this.finalStaticDT = data.finalStaticDT; // 全部文献
                    this.wxSearch();
                    this.replaceUrl2('?historyParams='); // 无刷新，改变地址栏
                }, 300);
            },
            professSearch2(data){ // 列表页-专业检索
                this.spinning = true; // 加载中...
                setTimeout(async () => {
                    if(this.isFirstDrag){
                        await this.getModelSortIndex(); // 获取文献模块历史位置
                        this.isFirstDrag = false;
                    }
                    this.toInit();                  // 初始化所有数据
                    let _datas      = data.datas;
                    this.searchType = data.searchType;
                    this.expression = data.expParams;
                    if(!this.isEmptyObject(_datas)){
                        // 文献检索
                        this.DT = _datas.DT;
                        _datas.TY.forEach((item)=>{
                            if(item == "P") this.namesSearchData();
                        })
                        this.wxSearch();
                    }
                    this.replaceUrl2('?historyParams='); // 无刷新，改变地址栏
                }, 300);
            },
            wxSearch(){ // 文献判断检索
                this.startTime = new Date().getTime();   // 检索开始时间
                this.keyword       = '';  // 清除简单检索条件
                this.ajaxStopFlag  = 0;   // 异步请求数量初始化
                this.agentUriArray = [];  // 清空所有人物url
                this.showSearchModel();   // 显示参与检索的文献
                this.DT.forEach((item, index)=>{
                    if(item === 'BK'){
                        this.docAllSearch('BK/newspaper')
                        this.docAllSearch('BK/magazine')
                    }
                    else this.docAllSearch(item);
                })

                // 检索埋点START
                if(this.activeUserInfo) {
                    this.params.DT = this.DT;
                    if(this.searchType == "2") {
                        this.createUserLog("https://dhc.library.sh.cn/result", this.params, "大数据平台-文献检索")
                    }
                    if(this.searchType == "3") {
                        this.createUserLog("https://dhc.library.sh.cn/result", this.params, "大数据平台-专业检索")
                    }
                }
                // 检索埋点END

                // 检索历史埋点START
                // if(this.activeUserInfo) {
                //     let _history = {
                //         "content": JSON.stringify(this.params)
                //     }
                //     if(this.isEmpty(this.params.freetext)) _history = null;
                //     this.hisRetAndOrdSetting(null, _history, null);
                // }
                // 检索历史埋点END
                
                /* 检索参数存储索引库 START */
                this.dhcLogSearchid();
                /* 检索参数存储索引库 END   */
            },
            searchIsEmpty(type){ // 定时判断检索是否为空
                let _timer = type + "Timer";
                this[_timer] = setTimeout(() => {
                    let _sizeKey    = type + 'Size';
                    let _listKey    = type + 'List';
                    let _isEmptyKey = type + 'IsEmpty';
                    if(this[_sizeKey] == 0 && this[_listKey].length==0) this[_isEmptyKey] = true;
                    
                    this.spinning = false; // 加载结束
                }, 2000);
            },
            showSearchModel(){ // 高级检索时，显示检索的文献，不参与检索的隐藏
                // 若文献全部没有勾选，则显示全部文献模块
                let _hideFlag = this.isEmptyArray(this.DT) > 0 ? false : true;
                this.finalStaticDT.forEach((item, index)=>{
                    if(item === "BK") {
                        this.bkHide    = _hideFlag;
                        this.bkMagHide = _hideFlag;
                    }
                    else this[item.toLowerCase() + 'Hide'] = _hideFlag;
                })

                clearTimeout(this.namesTimer); // 清除延迟执行
                if( this.isEmptyArray(this.DT) ) return;
                // 显示当前检索的文献
                this.DT.forEach((item, index)=>{
                    if(item === "BK") {
                        clearTimeout(this.bkTimer); // 清除延迟执行
                        clearTimeout(this.bkMagTimer); // 清除延迟执行
                        this.bkHide    = false;
                        this.bkMagHide = false;
                    }
                    else {
                        let _type = item.toLowerCase();
                        clearTimeout(this[_type+'Timer']); // 清除延迟执行
                        this[_type+'Hide'] = false;
                    }
                })
            },
            charts(){
                localStorage.wxResultVisParams = this.$qs.stringify(this.params);
                this.$router.push("/visualization");
                // this.$router.push({name:"chartsIndex", params:{visParams: JSON.stringify(this.params)}});
            },
            gisAnalysis() { // params
                // this.$router.push("/gisAnalysis");
                this.$router.push({name:"gisAnalysis", params:{mapParams: JSON.stringify(this.params)}});
            },
            resultExport: async function(){ // 结果导出
                let _this = this;
                if( !_this.Common.userInfo ){
                    _this.$Modal.info({ content : '请登录!', okText  : '确定', });
                    return;
                }
                if( !_this.isCheckboxModel() ){
                    _this.$Modal.info({ content : '请至少勾选一条内容!', okText  : '确定', });
                    return;
                }
                if(_this.hasCheckboxModel()){
                    await _this.$Modal.confirm({
                        title           : '结果导出',
                        content         : '每种文献最多导出100条数据，是否继续？',
                        cancelText      : '取消',
                        okText          : '确定',
                        confirmLoading  : false,
                        onCancel() { }, // 取消
                        async onOk() {  // 确定
                            // console.log(_this.$Modal)
                            // _this.$loading.show("正在导出...");
                            _this.pageSize = 100;
                            await _this.fullExportSearch();
                            // _this.$loading.hide();
                            _this.onResultExport();
                        },
                    });
                } else _this.onResultExport();
            },
            onResultExport(){ // 导出内容设置
                let _this = this;
                _this.pageSize = 10;
                let title      = [];     // csv文档标题
                let exportData = [];     // csv文档数据
                let fileName   = 'temp'; // 文件名
                let titleArr   = [
                    {ch:'标题',       en:"title"}, 
                    {ch:'作者',       en:"author"}, 
                    {ch:'出版时间',   en:"publicationTime"}, 
                    {ch:'出版地',     en:"place"}, 
                    {ch:'文献类型',   en:"source"}, 
                    {ch:'资源uri',    en:"uri"}
                ]; // 文档标题集合
                titleArr.forEach((item) => {
                    title.push({title: item.ch  , field: item.en});  // 设置标题
                })
                exportData = _this.wxModelExportData(); // 数据处理
                _this.JSONToExcelConvertor(title, exportData, fileName); // 导出csv文件
            },
            wxModelExportData(){ // 获取各文献模块导出数据
                let csvExportData = [];
                $.each(this.plainOptions, (index, item)=>{
                    let _type = item.replace('CheckedAllGroup', '');
                    let _checkAll       = _type + 'CheckAll';
                    let _indeterminate  = _type + 'Indeterminate';
                    let _checkedAllList = _type + 'CheckedAllList';
                    let _checkedList    = _type + 'CheckedList';
                    if(this[_checkAll]) 
                        this.getCsvExportData(this[_checkedAllList], csvExportData, _type);
                    if(this[_indeterminate]) 
                        this.getCsvExportData(this[_checkedList], csvExportData, _type);
                })
                return csvExportData;
            },
            getCsvExportData(oldArr, newArr, type){ // csv文件导出数据处理
                let _this = this;
                $.each(oldArr, (index, item)=>{
                    // publicationTime : item.edition.temporalValue[0]
                    newArr.push({
                        title           : item.title.value, 
                        author          : _this.arrayToString(item.co, 'chsAgent', '，'), 
                        publicationTime : item.is ? item.is.value : '',
                        place           : item.pl ? item.pl.chsPlc : '',
                        source          : item.DTNAME,
                        uri             : item['@id']
                    });
                })
            },
            fullExportSearch: async function(){ // 导出时，对全选的文献重新查询数据
                if( this.jpCheckAll    )  await this.docAllSearch('JP');    // 家谱
                if( this.gjCheckAll    )  await this.docAllSearch('GJ');    // 古籍
                if( this.sdCheckAll    )  await this.docAllSearch('SD');    // 盛档
                if( this.hswxCheckAll  )  await this.docAllSearch('HSWX');  // 红色文献
                if( this.jdtsCheckAll  )  await this.docAllSearch('JDTS');  // 近代图书
                if( this.bkCheckAll    )  await this.docAllSearch('BK/newspaper');  // 报刊（报）
                if( this.bkMagCheckAll )  await this.docAllSearch('BK/magazine');   // 报刊（刊）
            },
            onCheckAllModelChange(e){ // 全部全选复选框
                Object.assign(this, {
                    // checkedAllModelList: e.target.checked ? this.plainOptions : [],
                    indeterminate: false,
                    checkAllModel: e.target.checked
                });

                // 各文献模块全选
                let obj = {};
                $.each(this.plainOptions, (index, item)=>{
                    let _type            = item.replace('CheckedAllGroup', '');
                    let _list            = _type+'List';
                    let _indeterminate   = _type+'Indeterminate';
                    let _checkAll        = _type+'CheckAll';
                    let _checkedList     = _type+'CheckedList';
                    obj[_checkedList]    = e.target.checked ? this[_list] : [],
                    obj[_indeterminate]  = false,
                    obj[_checkAll]       = e.target.checked
                    this.checkedAllModelList.push(item);
                })
                this.checkedAllModelList = this.unique(this.checkedAllModelList, null); // 去重
                if(!this.checkAllModel) this.checkedAllModelList = [];

                Object.assign(this,  obj);
            },
            onCheckAllChange(e, type){ // 各文献模块全选复选框
                let _list            = type+'List';
                let _indeterminate   = type+'Indeterminate';
                let _checkAll        = type+'CheckAll';
                let _checkedList     = type+'CheckedList';
                let obj = {};
                obj[_checkedList]   = e.target.checked ? this[_list] : [];
                obj[_indeterminate] = false;
                obj[_checkAll]      = e.target.checked;
                Object.assign(this, obj);
                // 所有文献模块复选框勾选状态
                this.checkModelChangeFlag(type);
            },
            onCheckChange(checkedList, type){ // 最里层复选框勾选
                let _list            = type+'List';
                let _indeterminate   = type+'Indeterminate';
                let _checkAll        = type+'CheckAll';
                let _checkedList     = type+'CheckedList';
                if(checkedList.length == 0) this[_checkedList] = [];
                this[_indeterminate] = !!checkedList.length && checkedList.length < this[_list].length;
                this[_checkAll]      = checkedList.length === this[_list].length;
                this[_checkedList]   = checkedList;
                // 所有文献模块复选框勾选状态
                this.checkModelChangeFlag(type);
            },
            checkModelChangeFlag(type){ // 全部文献模块勾选判断
                let _indeterminate = type+'Indeterminate';
                let _checkAll      = type+'CheckAll';
                // 最外层复选框是否选中
                let _checkedAllGroup = type+'CheckedAllGroup';
                if(this[_checkAll]) this.checkedAllModelList.push(_checkedAllGroup)
                else this.checkedAllModelList = this.removeArray2(this.checkedAllModelList, _checkedAllGroup); // 删除数组元素
                
                // 各模块选中状态存储判断
                if(this[_indeterminate]) this.indeterminateModelList.push(_indeterminate);
                else this.indeterminateModelList = this.removeArray2(this.indeterminateModelList, _indeterminate); // 删除数组元素
                
                this.indeterminate = this[_indeterminate] || !this.isEmptyArray(this.indeterminateModelList) || 
                    (!this.isEmptyArray(this.checkedAllModelList) && this.checkedAllModelList.length < this.plainOptions.length);
                this.checkAllModel = this.checkedAllModelList.length === this.plainOptions.length;
            },
            hasCheckboxModel(){ // 判断各文献模块其中是否存在全选
                let flag = false;
                $.each(this.plainOptions, (index, item)=>{
                    let _type     = item.replace('CheckedAllGroup', '');
                    let _checkAll = _type+'CheckAll';
                    if(this[_checkAll]){
                        flag = true;
                        return false;
                    }
                })
                return flag;
            },
            isCheckboxModel(){ // 复选框是否选中
                let flag = false;
                $.each(this.plainOptions, (index, item)=>{
                    let _type          = item.replace('CheckedAllGroup', '');
                    let _checkAll      = _type+'CheckAll';
                    let _indeterminate = _type+'Indeterminate';
                    if(this[_indeterminate] || this[_checkAll]){
                        flag = true;
                        return false;
                    }
                })
                return flag;
            },
            highLight(text){
                return text.split(this.keyword).join('<b>'+this.keyword+'</b>')
            },
            changeInfoTap(item, index){ // 人物点击
                this.infoTap   = index; // 显示当前点击的人物
                this.namesInfo = item;  // 获取当前点击人物信息
                if(this.searchType == 2){
                    // 根据人物获取照片、事件
                    this.eventFreetext   = item.name;
                    this.namesFacetParam = item.name;
                    this.eventSearchData(); // 事件
                    this.photoSearchData(); // 照片
                }
            },
            ACS(a, b){ // 数组由小到大顺序排列
                return a-b;
            },
            DESC(a, b){ // 数组由大到小倒序排列
                return b-a;
            },
            objectArraySort(keyName) { // 排序，由大到小
                return function (objectN, objectM) {
                    var valueN = objectN[keyName]
                    var valueM = objectM[keyName]
                    if (valueN < valueM) return 1
                    else if (valueN > valueM) return -1
                    else return 0
                }
            },
            yearClick(year){
                this.bigEventCode = 0;
                this.bigEventData = null;
                this.eventColorFlag = -1;
                this.eventList = [];
                this.yearDataArray.forEach((item) => {
                    if(item.year == year){
                        this.eventList.push(item.data);
                    }
                })
            },
            searchAllTypeData(){
                this.finalStaticDT.forEach((itme, index)=>{
                    if(itme == 'BK') {
                        this.docAllSearch('BK/newspaper');
                        this.docAllSearch('BK/magazine');
                    } 
                    else {
                        this.docAllSearch(itme);
                    }
                })
            },
            photoEvent(lt){
                let personUri = lt.personUri;
                if(personUri && personUri.indexOf(";") != -1) 
                    personUri = personUri.split(";")[0];
                window.open('https://ldy.library.sh.cn/person/personDetailAll?uri='+personUri);
            },
            namesArrayHandle(agentUri){ // 人物数组处理
                let personArr = [];
                agentUri.forEach((item) => {
                    if(item.facet.indexOf('/gj/') == -1){ // 排除包含古籍的人物uri
                        personArr.push(item);
                    }
                });
                personArr.sort(this.objectArraySort('count')).slice(0,3);
                this.agentUriArray.push.apply(this.agentUriArray, personArr);
            },
            namesHandle(nameType, nameType2, data){ // 名字分类处理
                if(data == null || data.length == 0) return '';
                let arr = new Array();
                data.forEach((item) => {
                    if(!item.nameType) return;
                    if(!this.isEmpty(nameType)  && item.nameType.indexOf(nameType) != -1){
                        arr.push(item.label);
                    }
                    if(!this.isEmpty(nameType2) && item.nameType.indexOf(nameType2) != -1){
                        if(nameType2 == '号' && item.nameType.indexOf('谥号') != -1) return;
                        arr.push(item.label);
                    }
                });
                return this.unique(arr, null).slice(0, 2).join(' ');
            },
            async namesSearchData(){
                let params = {
                    "searchType": this.searchType,
                    "expression": this.expression,
                    "freetext":   this.keyword,
                    "cdtn":       this.namesCdtn,
                    "facet":      this.facet,
                    "secondCdtn": "",
                    "pager": {
                        "pageth": 1
                    },
                    "sorts": {},
                    "hasFacet": false
                };
                await this.$axios.post(this.Common.personSearchUrl, params)
                .then((res) => {
                    let resultData = res.data.data;
                    this.namesSize = resultData.pager.rowCount;
                    this.searchIsEmpty("names");
                    if( this.searchType == 1 ){ // 简单检索 处理
                        this.namesList = resultData.datas;
                    }
                    else { // 高级检索 处理
                        this.namesList.push.apply(this.namesList, resultData.datas);
                    }
                    sessionStorage.setItem('namesList',JSON.stringify(this.namesList))
                    if(this.isFirstPerson || this.isEmptyObject(this.namesInfo)) {
                        this.namesInfo     = this.namesList[0]; // 获取第一个人物信息
                        this.isFirstPerson = false;
                        if( this.searchType == 2 ){ // 高级检索进入
                            // 根据人物获取照片、事件
                            this.eventFreetext   = this.namesInfo.name;
                            this.namesFacetParam = this.namesInfo.name;
                            this.eventSearchData();
                            this.photoSearchData();
                        }
                    }
                })
                .catch((err) => {
                    console.log(err)
                    this.namesIsEmpty = true;
                });
            },

            photoSearchData(){
                let params = {
                    "freetext" :        this.keyword,      // 简单检索
                    "facetContributor": this.namesFacetParam, // 人物
                };
                this.$axios.post( this.Common.getPhotoUrl, this.$qs.stringify(params) )
                .then((res) => {
                    let resultData = res.data;
                    this.photoList = resultData.data;
                })
                .catch((err) => {
                    console.log(err)
                });
            },
            eventTitleClick(lt, index){
                this.bigEventCode = 1;
                this.bigEventData = lt;
                this.eventColorFlag = index;
            },
            eventSearchData(){
                let eventParams = this.params;
                if(this.searchType == 2) eventParams = {
                    searchType: 1,
                    freetext: this.eventFreetext
                };
                this.$axios.post( this.Common.getEventUrl, eventParams)
                .then((res) => {
                    let resultData = res.data.data;
                    this.eventList = resultData.result;
                    this.eventSize = resultData.pager.rowCount;
                    // this.searchIsEmpty("eventIsEmpty", this.eventSize);
                    this.eventTimelineHandle(this.eventList);
                })
                .catch((err) => {
                    console.log(err)
                    // this.eventIsEmpty = true;
                });
            },
            eventTimeline(year, index){ // 时间轴 年份点击
                if(this.yearSlide != -1 && this.yearSlide == index){
                    this.yearSlide = -1;
                } else {
                    // 年份
                    this.year = [];
                    this.yearDataArray.forEach((item) => {
                        if(item.id == year){
                            this.year.push(item.year);
                        }
                    })
                    // 去重及排序（年份由大到小）
                    this.year = this.unique(this.year, this.DESC);
                    this.yearSlide = index;
                }
            },
            eventTimelineHandle(eventList){ // 时间轴 事件相关年份处理
                this.yearArray     = []; // 事件相关年份整数，如：1910，1920...
                this.yearDataArray = []; // 相关年份的事件集合
                if( !this.isEmptyArray(eventList) ){
                    eventList.forEach((item) => {
                        let _year_zero = 0; // 尾数为零的年份
                        let _beginYear = 0; // 年月日中剔除月份和日份后的年份
                        let begin = item.begin; // 事件起始年月
                        if(begin.length > 4){
                            _year_zero = begin.slice(0, begin.indexOf('-')-1) + 0;
                            _beginYear = begin.slice(0, begin.indexOf('-'));
                        }
                        else {
                            _year_zero = begin.slice(0, begin.length-1)+0;
                            _beginYear = begin;
                        }

                        this.yearArray.push(_year_zero);
                        this.yearDataArray.push({id: _year_zero, year: _beginYear, data: item})
                    });
                    // 去重及排序（年份由大到小）
                    this.yearArray = this.unique(this.yearArray, this.DESC);
                }
            },
            docAllSearch: async function(dtType){
                let _type = dtType.toLowerCase();
                if(dtType == 'BK/newspaper') _type = 'bk';
                if(dtType == 'BK/magazine' ) _type = 'bkMag';
                await this.$axios.post(this.Common.docAllSearchUrl+dtType, this.params)
                .then((res) => {
                    let resultData = res.data.data;
                    let _list = _type + 'List';
                    let _size = _type + 'Size';
                    let _checkAll = _type + 'CheckAll';
                    if(this[_checkAll]) {
                        let _checkedAllList = _type + 'CheckedAllList';
                        this[_checkedAllList] = resultData.datas;
                    } 
                    else {
                        // 复选框，页面显示的文献模块
                        let _checkedAllGroup = _type+'CheckedAllGroup';
                        if(this.plainOptions.indexOf(_checkedAllGroup) == -1) this.plainOptions.push(_checkedAllGroup);
                        // 去重
                        if(!this.isEmptyArray(this.plainOptions)) 
                            this.plainOptions = this.unique(this.plainOptions, null);
                        
                        this[_list] = resultData.datas;
                        sessionStorage.setItem(_list,JSON.stringify(this[_list]))
                        this[_size] = resultData.pager.rowCount;

                        this.setFullWxItemsList(_type);             // 文献模块显示数据设置
                        this.searchIsEmpty(_type);                  // 定时判断当前文献检索是否为空
                        this.endTime = new Date().getTime();        // 检索结束时间
                        // 相关人物url集合
                        let agentUri = resultData.facets.agentUri;
                        if(!this.isEmptyArray(agentUri)) this.namesArrayHandle(agentUri);
                        if(dtType != 'BK/magazine') this.ajaxStopFlag++
                    }
                })
                .catch((err) => {
                    this[_type+'IsEmpty'] = true;
                    console.log(err)
                });
            },
            getSettingBody(obj){ // 拖拽顺序body参数设置
                let _retrieval = { 
                    "content": obj.retContent ? obj.retContent : JSON.stringify(['李鸿章','张恨水','鲁迅','严独鹤','啼笑因缘']),
                    "display": obj.retDisplay ? obj.retDisplay : 'Y',
                };
                
                let _history = {
                    "content": obj.hisContent ? obj.hisContent : JSON.stringify(['历史记录Test']),
                    "display": obj.hisDisplay ? obj.hisDisplay : 'Y',
                };

                let _orders = obj.orders ? obj.orders : [{"orderCode":'', "orderName": ''}];

                this.settingBody = {
                    "retrieval": _retrieval, // 检索框提示
                    "history"  : _history,   // 检索历史
                    "orders"   : _orders     // 历史拖拽顺序
                }
            },
            async settingHandle(){ // 文献模块拖拽顺序存储
                await this.$axios.post( this.Common.settingHandleUrl, this.settingParams)
                .then((res) => {
                    let resultData = res.data;
                    console.log(resultData.message);
                    // this.$message.success(resultData.message, 1);
                    // window.localStorage.removeItem('modelSortsObj'); // 删除本地记录
                })
                .catch((err) => {
                    console.log(err)
                });
            },
            async searchSetting(){ // 文献模块拖拽历史查询
                this.settingBody = {};
                await this.$axios.post( this.Common.searchSettingUrl, this.settingParams)
                .then((res) => {
                    let resultData = res.data;
                    let len = this.isEmptyArray(resultData.body) ? -1 : resultData.body.length-1;
                    let _orders = len==-1 ? null : resultData.body[len].orders;
                    if( !this.isEmptyArray(_orders) && _orders.length == 7 ) this.sortIndexHandle(_orders);
                    else {
                        let _defaultOrders = this.defaultOrders();
                        this.getSettingBody({ orders: _defaultOrders });
                        this.settingBody.retrieval = null;
                        this.settingBody.history   = null;
                        this.settingHandle();
                    }
                })
                .catch((err) => {
                    console.log(err)
                });
            },
            dhcLogSearchid(){
                this.$axios.post(this.Common.dhcLogUri, this.params)
                .then((res) => {
                    let resultData = res.data;
                    this.searchid  = resultData.data.id;
                })
                .catch((err) => {
                    console.log(err)
                });
            },
            replaceHighlight(str){ // 替换字符串，高亮显示
                let des = str;
                if( !this.isEmpty(this.keyword) ) {
                    des = str.replace(new RegExp(this.keyword, "g"), ('<b>'+this.keyword+'</b>'));
                }
                return des;
            },
            sortIndexHandle(arr){ // 获取模块顺序
                if( !this.isEmptyArray(arr)) {
                    for(var index in arr){
                        let _modelSort   = arr[index];
                        let orderCode    = _modelSort.orderCode;
                        let orderName    = _modelSort.orderName;
                        let _sortIndex   = orderCode+'SortIndex';
                        this[_sortIndex] = Number(index);
                    }
                }
            },
            async getModelSortIndex(){ // 获取文献模块历史位置
                if(this.activeUserInfo) await this.searchSetting();
                else {
                    // 获取本地存储的模块顺序
                    let _modelSortArray = localStorage.modelSortsObj ? JSON.parse(localStorage.modelSortsObj):[];
                    if( !this.isEmptyArray(_modelSortArray)) this.sortIndexHandle(_modelSortArray);
                }
            },
            modelSortIndex(){ // 存储拖拽顺序到localStorage
                if(this.finalStaticDT.length < 6) return; // 模块若没有全部显示，则不做存储
                // 获取本地存储的模块顺序    jpSortIndex
                let _modelSortArray = [];
                this.fullWxItemsList.forEach((item, index)=>{
                    _modelSortArray.push({
                        orderCode: item.type,
                        orderName: item.wxName
                        // orderName: this.modelChs(item.type)
                    });
                })
                
                if(this.activeUserInfo) {
                    this.getSettingBody({ orders: _modelSortArray });
                    this.settingBody.retrieval = null;
                    this.settingBody.history   = null;
                    this.settingHandle();
                }
                else localStorage.modelSortsObj = JSON.stringify(_modelSortArray);
            },
            defaultOrders(){ // 文献默认顺序
                return [
                    { orderCode: 'jp', orderName: '家谱' },
                    { orderCode: 'gj', orderName: '古籍' },
                    { orderCode: 'sd', orderName: '盛档' },
                    { orderCode: 'bk', orderName: '报刊(报)' },
                    { orderCode: 'bkMag', orderName: '报刊(刊)' },
                    { orderCode: 'hswx' , orderName: '红色文献' },
                    { orderCode: 'jdts' , orderName: '近代图书' },
                ]
            },
            modelChs(prop){
                let _chs = {
                    "jp"    : "家谱",
                    "gj"    : "古籍",
                    "sd"    : "盛档",
                    "bk"    : "报刊(报)",
                    "bkMag" : "报刊(刊)",
                    "hswx"  : "红色文献",
                    "jdts"  : "近代图书",
                }
                return _chs[prop];
            },
            handleDragStart(e,item){ // 拖拽开始
                this.dragging = item;
            },
            handleDragEnd(e,item){   // 拖拽结束
                this.dragging = null
                this.modelSortIndex();
            },
            //首先把div变成可以放置的元素，即重写dragenter/dragover
            handleDragOver(e) {
                e.dataTransfer.dropEffect = 'move'// e.dataTransfer.dropEffect="move";//在dragenter中针对放置目标来设置!
            },
            handleDragEnter(e,item){
                e.dataTransfer.effectAllowed = "move"//为需要移动的元素设置dragstart事件
                if(item === this.dragging){
                    return
                }
                const newItems = [...this.fullWxItemsList]
                const src = newItems.indexOf(this.dragging)
                const dst = newItems.indexOf(item)
        
                newItems.splice(dst, 0, ...newItems.splice(src, 1))
        
                this.fullWxItemsList = newItems
            }
        },
        watch: {
            ajaxStopFlag: async function(){
                let len = this.DT.length;
                if(len > 0 && this.ajaxStopFlag%len == 0){
                    if(this.isEmptyArray(this.agentUriArray)) {
                        this.searchIsEmpty("names")
                        return;
                    }
                    if(this.agentUriArray.length > 3){
                        this.agentUriArray.sort(this.objectArraySort('count')).slice(0,3);
                    }
                    this.isFirstPerson = true;
                    this.agentUriArray.forEach(async (item) => {
                        this.namesCdtn = [];
                        this.namesCdtn.push({
                            "logic": "",
                            "field": "URI",
                            "value": item.facet,
                            "type": "1"
                        });
                        await this.namesSearchData();
                    })
                }
            }
        }
    }
</script>

<style scoped lang="less">
    .from-cell{ // 检索不出数据，隐藏当前文献
        &.cur{
            display: none!important;
        }
    }
    .result-main-box{
        background: #19234b;
        width: 100%;
        min-height: calc(100vh);
    }
    
    .result-main{
        width: 100%;
        padding: 0 20px;
        &.cur{
            opacity: 0.1;
        }
        .top-ctrl{
            width: 100%;
            display: flex;
            justify-content: flex-end;
            align-items: center;
            span{
                color: #f0be73;
                margin-left: 20px;
                line-height: 30px;
                display: flex;
                justify-content: center;
                align-items: center;
                cursor: pointer;
                &.cur{
                    background-image: url("/loading.png");
                }
                img{
                    max-height: 20px;
                    margin-right: 5px;
                }
            }
        }
    }
    .result-container{
        display: flex;
        justify-content: space-between;
        padding: 0 0 0 40px;
        margin-top: 10px;
        color: #fff;
        .left-box{
            width: 27%;
            .ts{ // 人名 检索
                background: #222f60;
                border-top-right-radius: 5px;
                border-top-left-radius: 5px;
                line-height: 26px;
                text-align: left;
                padding: 5px 15px;
                span{
                    color: #00afeb;
                    padding: 0 4px;
                }
            }
            .waterfall-list{
                margin-top: 20px;
                display: flex;
                flex-direction: row;
                flex-wrap: wrap;
                transform: scale(0);
                transition: opacity .2s .1s,transform .5s .1s;
                &.cur{
                    opacity: 1;
                    transform: scale(1);
                }
                ul{
                    width: 31%;
                    margin-right: 2%;
                    font-size: 12px;
                    li{
                        position: relative;
                        width: 100%;
                        list-style: none;
                        border-radius: 10px;
                        overflow: hidden;
                        margin-bottom: 10px;
                        &:nth-child(3n){
                            margin-right: 0;
                        }
                        img{
                            width: 100%;
                            height: auto;
                            cursor: pointer;
                        }
                        &:hover{
                            .hover-box{
                                opacity: 1 ;
                            }
                        }
                        .hover-box{
                            position: absolute;
                            width: 100%;
                            height: 100%;
                            top: 0;
                            left: 0;
                            opacity: 0;
                            transition: opacity .4s;
                            display: flex;
                            flex-direction: column;
                            padding: 5px;
                            justify-content: space-between;
                            align-items: center;
                            .btn{
                                width: 95%;
                                display: flex;
                                justify-content: flex-end;
                                align-items: center;
                                a{
                                    width: 26px;
                                    height: 26px;
                                    border-radius: 13px;
                                    background: #c0bfbf;
                                    text-align: center;
                                    line-height: 26px;
                                    margin-left: 10px;
                                    color: #2e3e7a;
                                    font-weight: bold;
                                }
                            }
                            .save{
                                width: 95%;
                                background: rgba(255,255,255,.7);
                                height: 30px;
                                color: #2e3e7a;
                                line-height: 30px;
                                padding-left: 9px;
                                border-radius: 5px;
                                display: flex;
                                justify-content: space-between;
                                overflow: hidden;
                                button{
                                    background: #2e3e7a;
                                    height: 30px;
                                    line-height: 30px;
                                    color: #fff;
                                    padding: 0 9px;
                                }
                            }
                        }
                    }
                }
            }
            .info-box{
                width: 100%;
                background: #2e3f7a;
                padding: 15px 15px 60px 15px;
                position: relative;
                border-top-right-radius: 5px;
                border-bottom-right-radius: 5px;
                opacity: 0;
              transform: scale(0);
              transition: opacity .2s,transform .5s;
              h4{ // 人名标题
                color: #fff;
                margin-left: 10px;
                margin-bottom: 6px;
                span {
                    color: #00afeb;
                }
              }
              &.cur{
                opacity: 1;
                transform: scale(1);
              }
                .bottom{
                    position: absolute;
                    width: 100%;
                    height: 60px;
                    bottom: 0;
                    left: 0;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    .more{
                        position: absolute;
                        width: 40px;
                        left: -40px;
                        height: 60px;
                        border-bottom-left-radius: 5px;
                        background: #222f60;
                        border-top-left-radius: 5px;
                        text-align: center;
                        line-height: 60px;
                    }
                    .ot{
                        display: flex;
                        .all.look{ // 人名，查看按钮
                            // justify-content: flex-end;
                            color: #fff;
                            font-size: 12px;
                            img{
                                max-height: 18px;
                            }
                        }
                    }
                    a{
                        color: #f0be73;
                        margin: 0 10px;
                        height: 30px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                      img{
                        margin-right: 5px;
                        max-height: 20px;
                      }
                    }
                }
                .bottom.cur{ // 人名，查看按钮
                    justify-content: flex-end;
                }
                .taps{
                    position: absolute;
                    width: 40px;
                    top: 0;
                    left: -40px;
                    span{
                        display: block;
                        width: 40px;
                        padding: 10px;
                        box-sizing: border-box;
                        border-bottom-left-radius: 5px;
                        background: #222f60;
                        border-top-left-radius: 5px;
                        cursor: pointer;
                        &.cur{
                            background: #2e3f7a;
                        }
                        /deep/ b{
                            font-weight: normal;
                            color: #f0be73;
                        }
                    }
                }
                .detail{
                    display: flex;
                    align-items: flex-start;
                    justify-content: space-between;
                    // 人名，固定最小高度
                    min-height: 300px;
                    &.cur { // 人名，没数据时最小高度
                        min-height: 100px;
                    }
                    img{
                        width: 45%;
                        height: auto;
                    }
                    .txt{
                        flex-grow: 1;
                        margin-left: 10px;
                        font-size: 12px;
                        p{
                            line-height: 1.4;
                            margin: 0;
                        }
                        table{
                            width: 100%;
                            border: 1px solid #fff;
                            margin-top: 10px;
                            tr{
                                border-bottom: 1px solid #fff;
                            }
                            td{
                                padding: 4px 7px;
                                border-right: 1px solid #fff;
                            }
                        }
                    }
                }
            }
        }
        .middle-result{
            width: 44%;
            transform: scale(0);
            transition: opacity .2s .2s,transform .5s .2s;
            &.cur{
                opacity: 1;
                transform: scale(1);
            }
            .re-tit{
                background: #222f60;
                border-top-right-radius: 5px;
                border-top-left-radius: 5px;
                line-height: 26px;
                text-align: right;
                padding: 5px 15px;
                .check-all{
                    float: left;
                    .ant-checkbox-wrapper {
                        color: #fff;
                    }
                }
            }
            .result-from{
                .transition-container{
                    width: 100%;
                    height: 100%;
                    position: relative;
                    left: 0;
                    display:flex;
                    flex-direction: column;
                    padding: 0;
                    .item {
                        // margin-top: 10px;
                        transition: all linear .3s;
                        .ant-checkbox-group{
                            font-size: 12px;
                        }
                    }
                }
                .from-cell{
                    display: flex;
                    background: #2e3f7a;
                    color: #fff;
                    font-size: 12px;
                    &:nth-child(2n){
                        background: #222f60;
                    }
                    &.gj{
                        b{
                            color: #f0a032;
                        }
                        .arr{
                            .arrow{
                                color: rgba(240,160,50,1);
                            }
                            &:before{
                                background: linear-gradient(to bottom,rgba(240,160,50,0),rgba(240,160,50,1));
                            }
                            span{
                                background: rgba(240,160,50,1);
                            }
                            &:after{
                                background: linear-gradient(to bottom,rgba(240,160,50,1),rgba(240,160,50,0));
                            }
                        }
                        .ct-nox{
                            .ts{
                                span{
                                    color: #f0a032;
                                }
                            }
                            li{
                                &:before{
                                    background: #f0a032;
                                }
                            }
                        }
                    }
                    &.sd{
                        b{
                            color: #28c8af;
                        }
                        .arr{
                            .arrow{
                                color: rgba(42,160,160,1);
                            }
                            &:before{
                                background: linear-gradient(to bottom,rgba(42,160,160,0),rgba(42,160,160,1));
                            }
                            span{
                                background: rgba(42,160,160,1);
                            }
                            &:after{
                                background: linear-gradient(to bottom,rgba(42,160,160,1),rgba(42,160,160,0));
                            }
                        }
                        .ct-nox{
                            .ts{
                                span{
                                    color: #28c8af;
                                }
                            }
                            li{
                                &:before{
                                    background: #28c8af;
                                }
                            }
                        }
                    }
                    .ct-nox{
                        padding: 10px 10px 10px 0;
                        margin-left: 15px;
                        flex-grow: 1;
                        .ts{
                            line-height: 1.4;
                            font-size: 14px;
                            margin-bottom: 6px;
                            span{
                                color: #00afeb;
                                padding: 0 4px;
                            }
                        }
                        ul{
                            transition: height .5s;
                            li{
                                pointer-events: none;
                                opacity: 0;
                                transition: opacity .3s,transform .3s;
                                transform: scale(1,0);
                                &.cur{
                                    pointer-events: auto;
                                    opacity: 1;
                                    transform: scale(1,1);
                                }
                            }
                        }
                        .more{
                            color: #999;
                            padding-left: 5px;
                            display: flex;
                            justify-content: space-between;
                            span{
                                cursor: pointer;
                            }
                            a{
                                color: #fff;
                              img{
                                max-height: 18px;
                              }
                            }
                        }
                        li{
                            position: relative;
                            padding-left: 5px;
                            &:before{
                                position: absolute;
                                width: 6px;
                                height: 6px;
                                background: #00afeb;
                                content: "";
                                left: -22px;
                                top: 8px;
                                border-radius: 50%;
                            }
                            a{
                                color: #fff;
                                line-height: 22px;
                                display: block;
                                width: 100%;
                                height: 22px;
                                overflow: hidden;
                                white-space: nowrap;
                                text-overflow: ellipsis;
                                // 解决字符过长，换行
                                word-break: break-all;
                                word-wrap: break-word;
                                white-space: normal;
                                display: initial;
                                // white-space: nowrap;
                                &:hover{
                                    text-decoration: underline;
                                }
                            }
                        }
                    }
                    b{
                        width: 55px;
                        font-size: 24px;
                        line-height: 1.4;
                        font-family: FZZJ-LJDXKJW;
                        font-weight: normal;
                        padding: 15px 15px;
                        color: #00afeb;
                        opacity: .8;
                    }
                    .arr{
                        width: 7px;
                        position: relative;
                        .arrow{
                            position: absolute;
                            bottom: 15px;
                            left: 50%;
                            transform: translate(-50%,0);
                            color: rgba(0,175,235,1);
                        }
                        &:before{
                            position: absolute;
                            content: "";
                            background: linear-gradient(to bottom,rgba(0,175,235,0),rgba(0,175,235,1));
                            width: 1px;
                            height: 20%;
                            top: 0;
                            left: 3px;
                        }
                        span{
                            position: absolute;
                            background: rgba(0,175,235,1);
                            width: 1px;
                            bottom: 20%;
                            top: 20%;
                            left: 3px;
                        }
                        &:after{
                            position: absolute;
                            content: "";
                            background: linear-gradient(to bottom,rgba(0,175,235,1),rgba(0,175,235,0));
                            width: 1px;
                            height: 20%;
                            bottom: 0;
                            left: 3px;
                        }
                    }
                }
            }

            // 多选框样式
            /deep/ .ant-checkbox-wrapper:hover .ant-checkbox-inner, 
            .ant-checkbox:hover .ant-checkbox-inner, 
            .ant-checkbox-input:focus + .ant-checkbox-inner{
                border-color: transparent!important;
                border: 1px solid #fff!important;
                background-color: transparent!important;
            }
            /deep/ .ant-checkbox-checked{
                &::after{
                    border: transparent!important;
                }
                .ant-checkbox-inner{
                    background-size: 81%!important;
                    background-repeat: no-repeat!important;
                    background-image: url('../../assets/images/check2.png')!important;
                    background-color: transparent!important;
                    border-color: transparent!important;
                    border: 1px solid #fff!important;
                    &::after{
                        border: transparent!important;
                    }
                }
            }
            /deep/ .ant-checkbox-inner{
                background-color: transparent!important;
                border-color: transparent!important;
                border: 1px solid #fff!important;
            }
            /deep/ .ant-checkbox-indeterminate{
                .ant-checkbox-inner{
                    &::after{
                        background-color: #fff!important;
                    }
                }
            }
        }
        .right-act{
            width: 27%;
            transform: scale(0);
            transition: opacity .2s .3s,transform .5s .3s;
            .ts{ // 历史事件检索
                // padding-left: 25px;
                margin-top: 15px;
                background: #222f60;
                border-top-right-radius: 5px;
                border-top-left-radius: 5px;
                line-height: 26px;
                text-align: left;
                padding: 5px 15px;
                span{
                    color: #00afeb;
                    padding: 0 4px;
                }
            }
            &.cur{
                opacity: 1;
                transform: scale(1);
            }
            .years-act{
                // margin-top: 15px;
                background: #222f60;
                border-radius: 5px;
                display: flex;
                font-size: 12px;
                .acts{
                    flex-grow: 1;
                    .act-cell{
                        background: #2e3f7a;
                        padding: 10px;
                        &:nth-child(2n){
                            background: none;
                        }
                        h4{
                            color: #fff;
                            line-height: 1.4;
                            a{
                                color: #fff;
                            }
                        }
                        h4.cur{ // 事件标题点击后颜色
                            a{
                                color: #f0be73;
                            }
                        }
                        p{
                            margin-bottom: 5px;
                        }
                        .des{
                            width: 100%;
                            height: 20px;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: normal;
                            /deep/b{
                                font-weight: normal;
                                color: #f0be73;
                                position: relative;
                                border-bottom: 1px dotted #f0be73;
                            }
                        }
                        .btn{
                            text-align: right;
                            margin-top: 10px;
                            a{
                                color: #fff;
                                margin-left: 10px;
                              img{
                                max-height: 18px;
                                margin-right: 4px;
                              }
                            }
                        }
                    }
                }
                .years{
                    position: relative;
                    width: 90px;
                    padding: 35px 0 35px 10px;
                    flex-shrink: 0;
                    .year-t{
                        padding-left: 20px;
                        max-height: 20px;
                        overflow: hidden;
                        position: relative;
                        margin-bottom: 15px;
                        transition: max-height .8s;
                        &.cur{
                            max-height: 250px;
                        }
                        &:before{
                            position: absolute;
                            left: 5px;
                            width: 7px;
                            height: 7px;
                            top: 7px;
                            border-radius: 50%;
                            background: rgba(240,190,115,1);
                            content: "";
                        }
                        p{
                            line-height: 20px;
                            margin: 0;
                            font-size: 13px;
                            cursor: pointer;
                        }
                        .slide-more{
                            margin-top: 10px;
                            li{
                                transform: translate(-10px,0);
                                opacity: 0;
                                pointer-events: none;
                                line-height: 18px;
                                margin-bottom: 3px;
                                cursor: pointer;
                                padding-left: 10px;
                                position: relative;
                                &:before{
                                    position: absolute;
                                    content: "";
                                    width: 4px;
                                    height: 4px;
                                    top: 7px;
                                    border-radius: 50%;
                                    background: rgba(240,190,115,1);
                                    left: 0;
                                }
                                &:nth-child(1){
                                    transition: opacity .3s,transform .3s;
                                }
                                &:nth-child(2){
                                    transition: opacity .3s .1s,transform .3s .1s;
                                }
                                &:nth-child(3){
                                    transition: opacity .3s .2s,transform .3s .2s;
                                }
                                &:nth-child(4){
                                    transition: opacity .3s .3s,transform .3s .3s;
                                }
                                &:nth-child(5){
                                    transition: opacity .3s .4s,transform .3s .4s;
                                }
                                &:nth-child(6){
                                    transition: opacity .3s .5s,transform .3s .5s;
                                }
                                &:nth-child(7){
                                    transition: opacity .3s .6s,transform .3s .6s;
                                }
                                &:nth-child(8){
                                    transition: opacity .3s .7s,transform .3s .7s;
                                }
                                &:nth-child(9){
                                    transition: opacity .3s .8s,transform .3s .8s;
                                }
                                &:nth-child(10){
                                    transition: opacity .3s .9s,transform .3s .9s;
                                }
                            }
                            &.cur{
                                li{
                                    pointer-events: auto;
                                    transform: translate(0,0);
                                    opacity: 1;

                                }
                            }
                        }
                    }
                    .line{
                        position: absolute;
                        top: 0;
                        bottom: 0;
                        left: 15px;
                        width: 7px;
                        &:before{
                            position: absolute;
                            top: 10px;
                            left: 3px;
                            width: 1px;
                            height: 30px;
                            background: linear-gradient(to bottom,rgba(240,190,115,0),rgba(240,190,115,1));
                            content: "";
                        }
                        span{
                            position: absolute;
                            left: 0;
                            width: 7px;
                            height: 7px;
                            border-radius: 50%;
                            background: rgba(240,190,115,1);
                            &:nth-child(1){
                                top: 40px;
                            }
                            &:nth-child(2){
                                bottom: 40px;
                            }
                        }
                        .l{
                            position: absolute;
                            background: rgba(240,190,115,1);
                            width: 1px;
                            left: 3px;
                            top: 40px;
                            bottom: 40px;
                        }
                        &:after{
                            position: absolute;
                            bottom: 10px;
                            left: 3px;
                            width: 1px;
                            height: 30px;
                            background: linear-gradient(to top,rgba(240,190,115,0),rgba(240,190,115,1));
                            content: "";
                        }
                    }
                }
            }
            .top-act{
                border-radius: 5px;
                background: #222f60;
                padding: 9px 20px;
                position: relative;
                color: #fff;
                .event-title{ // 历史事件标题
                    color: #fff;
                    span{
                        color: #00afeb;
                    }
                }
                .tag{
                    position: absolute;
                    top: -8px;
                    left: 15px;
                    width: 20px;
                }
                h4{
                    padding-left: 25px;
                    color: #fff;
                }
                .pic{
                    width: 30%;
                    float: right;
                }
                p.y{
                    padding-left: 25px;
                    margin: 0;
                    margin-bottom: 15px;
                }
                .des{
                    font-size: 12px;
                    line-height: 1.9;
                    text-indent: 2em;
                }
                .btn{
                    margin-top: 10px;
                    text-align: right;
                    a{
                        margin-left: 10px;
                        color: #fff;
                      img{
                        max-height: 18px;
                        margin-right: 4px;
                      }
                    }
                    a.all.cur{ // 事件，全部按钮
                        font-size: 12px;
                        img{
                            max-height: 18px;
                            margin-right: 0;
                        }
                    }
                }
            }
        }
    }
</style>
